/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneOption/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSelectOneOptionMulti from './TysiaSelectOneOptionMulti/index'
import TysiaSelectOneOptionMultiInput from './TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiInput/index'
import TysiaSelectOneOptionMultiText from './TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiText/index'
import TysiaSelectOneOptionSingle from './TysiaSelectOneOptionSingle/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaSelectOneOption({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption",
  isMultiChoice,
  size,
  onClick,
  isSelected,
  disabled,
  text = "Option",
  subtext,
  alignSelf
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!isMultiChoice}>
<TysiaSelectOneOptionSingle
  viewPath={`${viewPath}/TysiaSelectOneOptionSingle`}
 size={size}
 onClick={onClick}
 selected={isSelected}
 disabled={disabled}
 text={text}
 subtext={subtext}
/>
</fromFlow.When>
<fromFlow.When is={isMultiChoice}>
<TysiaSelectOneOptionMulti
  viewPath={`${viewPath}/TysiaSelectOneOptionMulti`}
 size={size}
 onChange={onClick}
 value={isSelected}
 alignSelf={alignSelf}
 disabled={disabled}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneOptionMultiInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiInput`}
/>
<TysiaSelectOneOptionMultiText
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiText`}
 text={text}
 subtext={subtext}
/>
</React.Fragment>
)}
</TysiaSelectOneOptionMulti>
</fromFlow.When>
{children}
</React.Fragment>)
}